import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ToastService } from '@web/shared/ui';
import { AdminShippingSettingsApiService } from '../api/services/admin-shipping-settings-api.service';
import { AdminShippingSettingsFormData } from '../models/admin-shipping-settings-form-data';
import { AdminShippingSettingsUpdateRequest } from '../api/requests/admin-shipping-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminShippingSettingsDataSourceService {
  private readonly shippingSettingsApi = inject(
    AdminShippingSettingsApiService,
  );
  private readonly toast = inject(ToastService);

  public fetchSettingsFormData(): Observable<AdminShippingSettingsFormData> {
    return this.shippingSettingsApi.fetchSettings({ skipByLoading: true }).pipe(
      map(
        (response) =>
          new AdminShippingSettingsFormData({
            labelFetchRetries: response.labelFetchRetries,
            labelsInFile: response.labelsInFile,
            maxPackagesInNationalShipment: response.maxPackagesInNationalShipment,
            maxPackagesInInternationalShipment: response.maxPackagesInInternationalShipment,
            senderFirstName: response.senderFirstName,
            senderLastName: response.senderLastName,
            senderEmail: response.senderEmail,
            senderPhonePrefix: response.senderPhonePrefix,
            senderPhoneNumber: response.senderPhoneNumber,
            senderCompany: response.senderCompany,
            warehouseCountryCode: response.warehouseCountryCode,
            warehouseCity: response.warehouseCity,
            warehouseStreet: response.warehouseStreet,
            warehousePostCode: response.warehousePostCode,
            warehouseHouseNumber: response.warehouseHouseNumber,
            warehouseFlatNumber: response.warehouseFlatNumber,
          }),
      ),
    );
  }

  public updateSettingsByFormData(
    data: AdminShippingSettingsFormData,
  ): Observable<void> {
    return this.shippingSettingsApi
      .updateSettings(
        new AdminShippingSettingsUpdateRequest({
          labelFetchRetries: data.labelFetchRetries,
          labelsInFile: data.labelsInFile,
          maxPackagesInNationalShipment: data.maxPackagesInNationalShipment,
          maxPackagesInInternationalShipment: data.maxPackagesInInternationalShipment,
          senderFirstName: data.senderFirstName,
          senderLastName: data.senderLastName,
          senderEmail: data.senderEmail,
          senderPhonePrefix: data.senderPhonePrefix,
          senderPhoneNumber: data.senderPhoneNumber,
          senderCompanyName: data.senderCompany,
          warehouseCountryCode: data.warehouseCountryCode,
          warehouseCity: data.warehouseCity,
          warehouseStreet: data.warehouseStreet,
          warehousePostCode: data.warehousePostCode,
          warehouseHouseNumber: data.warehouseHouseNumber,
          warehouseFlatNumber: data.warehouseFlatNumber,
        }),
      )
      .pipe(
        tap(() => {
          this.toast.show((builder) =>
            builder
              .initSuccess('Konfiguracja wysyłki została zaktualizowana.')
              .build(),
          );
        }),
      );
  }
}
